export default "__VITE_ASSET__jzOfPvpm__"